const light = {
  color: {
    mainTitle: "#ff4c6b",
  },
};

export default light;
